import React, { useState, useContext, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LocaleContext from './contexts/locale.js'
import { Container, Row, Col, Button, Modal, Form, FormControl, ButtonGroup, Nav, Tab, ProgressBar, Image } from 'react-bootstrap';
import { translate } from 'react-polyglot'
import { format, addMonths, endOfMonth } from 'date-fns'
import DateTime from 'react-datetime';
import QRCode from 'qrcode.react'
import { useParams } from "react-router-dom"

import { getSelectedElement, getValue, myTimestampToDate, checkComponentPresence, makeid, propComparator, myDateToTimestamp } from "../util/ui_utils.js"

import DomainContext from './contexts/domainContext'
import GlobalDataContext from './contexts/globaldataContext.js';

import AlertSection from "./AlertSection.js"
import ElementFormMedia from "../components/FormMedia.js"
import { ModalInitButton } from './StructureGraphicElements.js'

import firebase from 'firebase/compat/app'

import { addEmployer as addEmployer2, editEmployer as editEmployer2 } from '../Firebase2/Storage2/dbEmployers';
import { uploadFileComplete as uploadFileComplete2 } from '../Firebase2/Storage2/dbFileStorage';



const section = 'employee_training'

function ModalEmployeeTraining({ item, setItem, t, is_new, small, index, item_list, setParentList, ui_list, canWrite, functions }) {
	const { domain } = useContext(DomainContext)

	let { cid } = useParams();
	let contractId = cid
	const childRefAlert = useRef()

	const newemployee = {
		firstname: '',
		lastname: '',
		cleaningcompany: {},
		address: {
			street: '',
			number: '',
			zip: '',
			city: '',
			state: ''
		},
		residence: {
			street: '',
			number: '',
			zip: '',
			city: '',
			state: ''
		},
		phone_list: [],
		register: '',
		photo: '',
		timing: 'permanentjob',
		birthdate: firebase.firestore.Timestamp.now(),
		id_expiration: firebase.firestore.Timestamp.now(),
		work_expiration: firebase.firestore.Timestamp.now(),
		assumption_date: firebase.firestore.Timestamp.now(),
		work_contract_id: -1,
		qualification_id: -1,
		training_list: [],
		clothing_list: [],
		structure_list: [],
		study_title: {}
	}

	const [showEmployeeEdit, setShowEmployeeEdit] = useState(false)
	const [curElement, setCurElement] = useState(newemployee)
	const [editedElement, setEditedElement] = useState(false)

	const [isInvalid, setIsInvalid] = useState(false)
	const [uploadingState, setUploadingState] = useState(-1)

	const handleCloseEmployee = () => setShowEmployeeEdit(false);

	const cb_progress = (status, byte, total) => {
		console.log(status, byte, total)
		try {
			console.log(byte / total)
			if (byte <total){
				setUploadingState(100 * byte / total)
			}else{
				setUploadingState(-1)
			}

		} catch (e) {
			console.warn("handleSaveMedia - error: ", e)
		}
	}
	const handleSaveEmployee = async () => {

		setShowEmployeeEdit(false);

		let error = false;
		if (curElement.firstname.length < 2) {
			error = true;
			childRefAlert.current.addAlert('danger', 'nome non valido')
		}
		if (curElement.lastname.length < 2) {
			error = true;
			childRefAlert.current.addAlert('danger', 'cognome non valido')
		}
		/* 		if (curElement.cleaningcompany === '-1' || Object.keys(curElement.cleaningcompany).length === 0 && curElement.cleaningcompany.constructor === Object) {
					error = true;
					childRefAlert.current.addAlert('danger', 'impresa non valida')
				} */
		if (is_new) {
			console.log(curElement)
			const cb_save = async (url, tracker) => {
				if (url) {
					curElement.photo = url
					curElement.photo_tracker = tracker
				}
				delete curElement.file
				const return_data = await addEmployer2(domain, contractId, curElement)
				let newemployee_list = [...item]
				newemployee_list.push(return_data)
				console.log(newemployee_list)
				setParentList(newemployee_list)
				setEditedElement(false)
			}

			if (curElement.file) {
				const mypath = contractId + '/' + section
				const mediainfo = { description: 'photo', source_name: curElement.file[0].name, section: section, item_reference: {} }
				let file_data = uploadFileComplete2(curElement.domain, '0', mypath, curElement.file[0], curElement.file[0].contentType, mediainfo, { cbProgress: cb_progress, cbSetDownload: cb_save })
				console.log("FILE", file_data)

			} else {
				cb_save()
			}

		} else {
			const cb_save = async (url, tracker) => {
				if (url) {
					curElement.photo = url
					curElement.photo_tracker = tracker
				}
				delete curElement.file
				let newemployee_list = [...item_list]
				const c = checkComponentPresence(curElement, item_list, 'id')
				newemployee_list.splice(c, 1, curElement)
				setParentList(newemployee_list)
				console.log("SAVE EMPLOYER", curElement, domain, contractId)
				const return_data = await editEmployer2(domain, contractId, curElement.id, curElement)
				setEditedElement(false)
			}
			if (curElement.file) {
				const mypath = contractId + '/' + section
				const mediainfo = { description: 'image', source_name: curElement.file[0].name, section: section, item_reference: {} }
				console.log(mediainfo, curElement.file[0])
				let file_data = uploadFileComplete2(domain, contractId, mypath, curElement.file[0], curElement.file[0].contentType, mediainfo, { cbProgress: cb_progress, cbSetDownload: cb_save })
				console.log("FILE", file_data)

			} else {
				cb_save()
			}
		}
	}


	const handleShowNewEmployee = () => {
		console.log('show new')
		setIsInvalid(false)
		setCurElement(newemployee)
		setShowEmployeeEdit(true)
		setEditedElement(false)
	}


	const handleShowEditEmployee = () => {
		if (!item.color) {
			item.color = { ...newemployee.color }
		}
		setIsInvalid(false)
		setCurElement(item)
		setShowEmployeeEdit(true)
		setTimeout(function () {
			setEditedElement(false)
		}, 100)
	}


	const onChangeHandler = (el) => {
		let { name, value, type } = el
        let sub = undefined;
        try {
            sub = el.getAttribute('sub') || el.sub
        } catch (err) { }
		if (type === 'radio') {
			if (value === 'true') {
				value = true
			} else if (value === 'false') {
				value = false
			}
		} else if (type === 'checkbox') {
			let oldcheck = []
			try {
				oldcheck = [...curElement[name]]
			} catch (err) { }
			if (el.checked) {
				if (oldcheck.indexOf(value) < 0) {
					oldcheck.push(value)
				}
			} else {
				if (oldcheck.indexOf(value) >= 0) {
					oldcheck.splice(oldcheck.indexOf(value), 1)
				}
			}
			value = oldcheck
		} else if (type === 'file') {
			console.log(el.files)
			value = el.files
			name = 'file'

		}
        if (sub) {
            value = { ...curElement[sub], [name]: value }
            name = sub;
        }
		console.log(name, value)
		setCurElement({ ...curElement, [name]: value })
		setEditedElement(true)
	}



	return (
		<>
			<ModalInitButton t={t} is_new={is_new} canWrite={canWrite} small={small} title_new={t('structure.labels.employee_add')} action_new={handleShowNewEmployee} action_edit={handleShowEditEmployee} action_info={handleShowEditEmployee} />
			<AlertSection ref={childRefAlert} />
			<Modal show={showEmployeeEdit} onHide={handleCloseEmployee} scrollable={true} fullscreen backdrop="static" className="bg-secondary">
				<Modal.Header closeButton className={editedElement ? "bg-warning" : ""}>
					<Modal.Title>

						{is_new ?
							<>
								<FontAwesomeIcon icon="plus-square" /> <span className="text-primary">{t('employes.labels.new_employee')}</span>
							</>
							:
							[canWrite ?
								<>
									<FontAwesomeIcon icon="pencil-alt" /> <span className="text-info">{t('employes.labels.edit')}</span>
								</>
								:
								<>
									<FontAwesomeIcon icon="info" /> <span className="text-info">{t('employes.labels.info_employee')}</span>
								</>
							]
						}
						: {curElement.firstname} {curElement.lastname}&nbsp;
						{editedElement ? <FontAwesomeIcon icon="save" /> : ''}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Container fluid>
						<ElementFormWorkContract element={curElement} t={t} functions={{ edit: onChangeHandler, setElement: setCurElement, updateData: functions.updateData }} ui_list={ui_list} canWrite={canWrite} />
					</Container>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleCloseEmployee}>
						{t('modal.close')}
					</Button>
					{canWrite ?
						<Button  disabled={isInvalid} className={editedElement ? "btn-warning" : "btn-primary"} onClick={handleSaveEmployee}>
							<FontAwesomeIcon icon="save" /> {t('modal.save')}
						</Button>
						: ''}
				</Modal.Footer>
			</Modal>
		</>
	)
}

function ElementFormWorkContract({ element, functions, t, ui_list, canWrite }) {

	const onChangeHandlerQualification = (q_id) => {

		const q = getSelectedElement(q_id, getSelectedElement(element.work_contract_id, ui_list.contract_list, 'id').qualification_list, 'id')
		console.log(q)
		if (q.id) {

			//			functions.edit({ name: 'qualification_id', value: q_id })

			if (q.training_list) {
				const _need_training_list = q.training_list.map(t => ({ ...t, execution_date: firebase.firestore.Timestamp.now(), expiration_date: firebase.firestore.Timestamp.now() }))
				//FIXME cerca tra eventuali titoli validi _> inserisci data di scadenza su lista nuova
				for (let nt of _need_training_list) {
					const training_list = element.training_list.filter(ct => ct.training_id === nt.id).sort(propComparator('expiration_date'))
					if (training_list.length > 0) {
						const training = training_list[0]
						nt.done = training.done
						nt.execution_id = training.id
						nt.execution_date = training.execution_date
						nt.expiration_date = training.expiration_date || ''
					} else {
						nt.done = false
						delete nt.execution_id
					}
				}
				functions.setElement({ ...element, clothing_list: q.clothing_list ? q.clothing_list : [], qualification_id: q_id, need_training_list: _need_training_list? _need_training_list: [] })
			} else {
				functions.setElement({ ...element, clothing_list: q.clothing_list ? q.clothing_list : [], qualification_id: q_id, need_training_list: [] })
			}
		} else {

			functions.setElement({ ...element, clothing_list: [], qualification_id: -1, need_training_list: [] })
		}

	}



	const checkTrainingValidity = () => {
		let _need_training_list = element.need_training_list
		if (_need_training_list) {
			console.log(_need_training_list)
			for (let nt of _need_training_list) {
				const training_list = element.training_list.filter(ct => ct.training_id === nt.id).sort(propComparator('expiration_date'))
				if (training_list.length > 0) {
					const training = training_list[0]
					nt.done = training.done
					nt.execution_id = training.id
					nt.execution_date = training.execution_date
					nt.expiration_date = training.expiration_date || ''
				} else {
					nt.done = false
					delete nt.execution_id
				}
			}
		}
		functions.edit({ name: 'need_training_list', value: _need_training_list || [] })
	}


	const onChangeHandlerWear = (value, index) => {
		let _clothing_list = [...element.clothing_list]
		_clothing_list[index]['clothing_size'] = value
		functions.edit({ name: 'clothing_list', value: _clothing_list })
	}
	const setTrainingList = (_training_list) => {
		console.log("SET TRAININT LIST")
		functions.edit({ name: 'training_list', value: _training_list })
	}
	useEffect(() => {
		checkTrainingValidity()

	}, [element.training_list])
	const updateTrainingList = (_training_list) => {
		let _need_training_list = element.need_training_list
		for (let nt of _need_training_list) {
			const training_list = _training_list.filter(ct => ct.training_id === nt.id).sort(propComparator('expiration_date'))
			if (training_list.length > 0) {
				const training = training_list[0]
				nt.done = training.done
				nt.execution_id = training.id
				nt.execution_date = training.execution_date
				nt.expiration_date = training.expiration_date || ''
			} else {
				nt.done = false
				delete nt.execution_id
			}
		}
		functions.setElement({ ...element, 'need_training_list': _need_training_list? _need_training_list: [], 'training_list': _training_list })
	}


	return (
		<>
			{element.work_contract_id && element.work_contract_id !== '-1' && element.work_contract_id !== -1 ?
				<>
					{console.log('training_list', element.training_list)}
					{element.training_list && element.training_list.length > 0 ?
						<Row className="border-bottom mb-1 pb-1">
							<Col>
								<Row>
									<Col className="bg-secondary text-light ms-1" sm="3">
										{t('global.labels.name')}
									</Col>
									<Col className="bg-secondary text-light ms-1">
										{t('employes.labels.done')}
									</Col>
									<Col className="bg-secondary text-light ms-1">
										{t('employes.labels.execution_date')}
									</Col>
									<Col className="bg-secondary text-light ms-1">
										{t('employes.labels.expiration_date')}
									</Col>
									<Col sm="5" className="bg-secondary text-light ms-1 text-center">{t('employes.labels.certificates')}</Col>
								</Row>
								{element.training_list.map((w, k) => (
									<OneTraining training={w} t={t} index={k} key={k} functions={{ setTrainingList: setTrainingList, updateTrainingList: updateTrainingList }} element={element} training_list={element.training_list} ui_list={ui_list} canWrite={canWrite}/>
								))}
							</Col>
						</Row>
						: <i>Nessun titolo conseguito</i>}

				</>
				: ''
			}
		</>
	)
}


////////////////////////////////////////////////////////////////////////////////////////////////////////
const OneNeedTraining = ({ t, training: need_training, index, training_list, functions, element, ui_list, canWrite }) => {


	const setItem = (el) => {
		let _titem_list = [...element.training_list]
		console.log("TRAINING LIST", _titem_list)
		if (need_training.done) {
			const c = checkComponentPresence(el, element.training_list, 'id', 'training_id')
			console.log("do", c)
			_titem_list.splice(c, 1, el)
		} else {
			el.training_id = el.id
			el.id = makeid(6)
			console.log("renew")
			_titem_list.push(el)
		}
		functions.setTrainingList(_titem_list)
	}

	const updateItem = (el) => {
		console.log("update")
		let _item_list = [...element.training_list]
		_item_list.splice(index, 1, el)
		functions(_item_list)

	}

	const getTrainingClass = (text) => {
		if (!need_training.done || (need_training.expiration && myTimestampToDate(need_training.expiration_date) < new Date())) {
			return text ? " text-danger" : " border-danger"
		} else {
			return ""
		}
	}

	return (
		<Row className={`border-bottom mb-1 pb-1` + getTrainingClass()}>
			<Col sm="5" className={getTrainingClass(true)}>
				{need_training.name}
			</Col>
			<Col>
				{need_training.done ?
					<>{t('employes.labels.done')}
					</> :
					<>{t('employes.labels.undone')}
					</>}
			</Col>
			<Col>

				{need_training.done ?
					<>
						{format(myTimestampToDate(need_training.execution_date), 'dd/MM/yyyy')}
					</> : ''}
			</Col>
			<Col className={getTrainingClass(true)}>
				{need_training.expiration && need_training.done ?
					<>
						{format(myTimestampToDate(need_training.expiration_date), 'dd/MM/yyyy')}
					</> : ''}
			</Col>
			<Col sm="2" className="text-center">
				{need_training.done ?
					<>
						{console.log("TR id", need_training.execution_id, need_training, element.training_list, getSelectedElement(need_training.id, element.training_list, 'training_id'))}
						<ModalOneTraining item={getSelectedElement(need_training.id, element.training_list, 'training_id')} is_new={false} setItem={setItem} t={t} ui_list={ui_list} mode={'edit'}  canWrite={canWrite}/>
						{need_training.expiration ?
							<>
								<ModalOneTraining item={need_training} is_new={true} setItem={setItem} t={t} small={true} ui_list={ui_list} mode={"renew"} canWrite={canWrite} />
							</>
							: <></>}
					</>
					:
					<>
						<ModalOneTraining item={need_training} is_new={true} small={true} setItem={setItem} t={t} ui_list={ui_list} mode={"do"}  canWrite={canWrite}/>
					</>
				}
			</Col>
		</Row>

	)

}



////////////////////////////////////////////////////////////////////////////////////////////////////////
const OneTraining = ({ t, training, index, functions, element, ui_list, canWrite }) => {



	const getTrainingClass = (text) => {
		if (!training.done || (training.expiration && myTimestampToDate(training.expiration_date) < new Date())) {
			return text ? " text-danger" : " border-danger"
		} else {
			return ""
		}
	}
	const handleDeleteTraining = () => {
		let _titem_list = [...element.training_list]
		console.log(_titem_list)
		const c = checkComponentPresence(training, element.training_list, 'id')
		_titem_list.splice(c, 1)
		functions.setTrainingList(_titem_list)

	}

	const setItem = (el) => {
		let _titem_list = [...element.training_list]
		console.log(_titem_list)
		console.log("do")
		const c = checkComponentPresence(el, element.training_list, 'id')
		_titem_list.splice(c, 1, el)
		functions.setTrainingList(_titem_list)
	}
	const updateItem = (el) => {
		console.log(el)
		let _et = training
		_et.media_list = el.value
		setItem(_et)
	}

	return (
		<Row className={`border-bottom mb-1 pb-1` + getTrainingClass()}>
			{console.log(training)}
			<Col sm="3" className={getTrainingClass(true)}>
				{training.name}
			</Col>
			<Col>
				{training.done ?
					<>{t('employes.labels.done')}
					</> :
					<>{t('employes.labels.undone')}
					</>}
			</Col>
			<Col>

				{training.done ?
					<>
						{format(myTimestampToDate(training.execution_date), 'dd/MM/yyyy')}
					</> : ''}
			</Col>
			<Col className={getTrainingClass(true)}>
				{training.expiration && training.done ?
					<>
						{format(myTimestampToDate(training.expiration_date), 'dd/MM/yyyy')}
					</> : ''}
			</Col>
			<Col sm="5" className="text-center">
				<ButtonGroup>
{/* 					<ModalOneTraining item={training} is_new={false} setItem={setItem} t={t} ui_list={ui_list} mode={'edit'} canWrite={canWrite}/>
 */}					
 {canWrite && <ElementFormMedia element={training} t={t} ui_list={ui_list} functions={{ edit: updateItem, save: updateItem }} section={section} canWrite={canWrite} />
}
{/* 					<Button size="sm" variant="danger" onClick={handleDeleteTraining}><FontAwesomeIcon icon="trash" /></Button>
 */}				</ButtonGroup>

			</Col>
		</Row>

	)

}

////////////////////////////////////////////////////////////////////////////////////////////////////////
function ModalOneTraining({ item, setItem, t, is_new, small, item_list, index, canWrite, all_training_list, ui_list, mode }) {
	const { domain } = useContext(DomainContext)

	const childRefAlert = useRef()

	const newtraining = {
		name: '',
		code: '',
		objectives: '',
		teaching_methodology: '',
		description: '',
		hour_length: 4,
		expiration: true,
		expiration_months: 24,
		execution_date: firebase.firestore.Timestamp.now(),
		expiration_date: firebase.firestore.Timestamp.now()
	}

	const [showEdit, setShow] = useState(false)
	const [curElement, setCurrentElement] = useState(newtraining)
	const [editedElement, setEditedElement] = useState(false)


	const handleShowEdit = () => {
		console.log("SHOW EDIT", is_new)
		if (is_new) {
			let new_t = { ...newtraining, ...item }
			console.log(new_t)
			setCurrentElement(new_t)

		} else {
			console.log(item)
			setCurrentElement(item)
		}
		setShow(true)
		setTimeout(function () {
			setEditedElement(false)
		}, 200)
	}


	const onChangeHandler = (el) => {
		console.log(el)
		let { name, value, type } = el
		if (type === 'radio') {
			if (value === 'true') {
				value = true
			} else if (value === 'false') {
				value = false
			}
		} else if (type === 'checkbox') {
			let oldcheck = curElement[name]
			if (el.checked) {
				if (oldcheck.indexOf(value) < 0) {
					oldcheck.push(value)
				}
			} else {
				if (oldcheck.indexOf(value) >= 0) {
					oldcheck.splice(oldcheck.indexOf(value), 1)
				}
			}
			value = oldcheck
		}
		if (name === 'done' && value === true && curElement.expiration) {
			setCurrentElement({ ...curElement, [name]: value, expiration_date: addMonths(new Date(), item.expiration_months) })
		} else {
			setCurrentElement({ ...curElement, [name]: value })

		}
		console.log(name, value)
		setEditedElement(true)
	}




	const onChangeTrainingDate = (value) => {
		let _date = new Date()
		try {
			_date = value
		} catch (err) {
			console.log("ERROR DATE", err)
		}
		if (curElement.expiration) {
			const _expiration_date = addMonths(_date, parseInt(curElement.expiration_months))
			console.log(_date, curElement.expiration_months,_expiration_date )
			setCurrentElement({ ...curElement, execution_date: firebase.firestore.Timestamp.fromDate(_date), expiration_date: firebase.firestore.Timestamp.fromDate(_expiration_date) })

		} else {
			setCurrentElement({ ...curElement, 'execution_date': firebase.firestore.Timestamp.fromDate(_date) })

		}
	}

	const handleClose = () => setShow(false);

	const handleSave = async () => {
		setItem(curElement)
		setShow(false)
		setEditedElement(false)
	}

	const ModeTitle = () => {
		if (mode === 'renew') {
			return ("rinnova")
		} else if (mode === 'do') {
			return ("esegui")
		} else if (mode === 'edit') {
			return ("modifica")
		} else {
			return ("error")
		}
	}

	return (
		<>
			<ModalInitButton t={t} is_new={is_new} canWrite={true} small={small} title_new={t('workcontract.labels.renew_training')} action_new={handleShowEdit} action_edit={handleShowEdit} action_info={handleShowEdit} />
			<AlertSection ref={childRefAlert} />
			<Modal show={showEdit} onHide={handleClose} className="bg-secondary" size="xl">
				<Modal.Header closeButton className={editedElement ? "bg-warning" : ""} >
					<Modal.Title>
						<ModeTitle />

						{is_new ?
							<>
								<FontAwesomeIcon icon="plus-square" /> <span className="text-primary">{t('employer.labels.new_training')}</span>
							</>
							:
							[canWrite ?
								<>
									<FontAwesomeIcon icon="pencil-alt" /> <span className="text-info">{t('employer.labels.edit_training')}</span>
								</>
								:
								<>
									<FontAwesomeIcon icon="info" /> <span className="text-info">{t('employer.labels.view_training')}</span>
								</>
							]
						}
						: {curElement.name}&nbsp;
						{editedElement ? <FontAwesomeIcon icon="save" /> : ''}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Container fluid>
						{is_new ?
							<Form.Group as={Row} controlId="eventSubject">
								<Form.Label column sm="2"> {t('global.labels.training')}</Form.Label>
								<Col>
									<Form.Control as="select" value={item.id} className="mb-2" name="training"
										onChange={(event) => onChangeHandler(event.currentTarget.value)} >
										<option value={"-1"} >{t('training.labels.select_training')}</option>
										{ui_list.training_list && ui_list.training_list.length > 0
											? [ui_list.training_list.map((f, k) => (
												<option key={k} value={f.id} >{f.name}</option>
											))]
											: ''
										}
									</Form.Control>
								</Col>
							</Form.Group>
							:
							<>
							</>
						}
						<Form.Group as={Row} className="border-bottom mb-1 pb-1" >
							<Form.Label column sm="2">{t('employes.labels.done')}</Form.Label>
							<Col sm="4">
								<Form.Check type="radio" name="done" value={true} checked={curElement.done} label={t('global.labels.yes')} onChange={(event) => onChangeHandler(event.currentTarget)} />
								<Form.Check type="radio" name="done" value={false} checked={!curElement.done} label={t('global.labels.no')} onChange={(event) => onChangeHandler(event.currentTarget)} />
							</Col>
						</Form.Group>
						{curElement.done ?
							<Form.Group as={Row} className="border-bottom mb-1 pb-1" >
								<Form.Label column sm="2">{t('employes.labels.execution_date')}</Form.Label>
								<Col sm="4">
									<DateTime initialValue={myTimestampToDate(curElement.execution_date)} dateFormat='DD/MM/YYYY' timeFormat={false} name={"execution_date"} locale="it" closeOnSelect={true} onChange={(e) => onChangeTrainingDate(e.toDate())} />
								</Col>
							</Form.Group>
							: ''
						}
						{(curElement.done && curElement.expiration) || !curElement.done ?
							<Form.Group as={Row} className="border-bottom mb-1 pb-1" >
								<Form.Label column sm="2">{t('employes.labels.expiration_date')}</Form.Label>
								<Col sm="4" className={myTimestampToDate(curElement.expiration_date)< new Date()? 'text-danger': ''}>
									{format(myTimestampToDate(curElement.expiration_date), 'dd/MM/yyyy')}
								</Col>
								<Col>
									{curElement.expiration_months} {t('global.labels.months')}
								</Col>
							</Form.Group>
							: <></>}
					</Container>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						{t('modal.close')}
					</Button>
					<Button className={editedElement ? "btn-warning" : "btn-primary"} form="companyForm" onClick={handleSave}>
						<FontAwesomeIcon icon="save" /> {t('modal.save')}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}




/* 
function ElementFormEducation({ element, functions, t, ui_list }) {

	const newqualification = {
		trainingdate: new Date(),
		name: {},
		level: {},
		active: true
	}
	const [showTrainingEdit, setShowTrainingEdit] = useState(false)
	const [newTrainingEdit, setNewTrainingEdit] = useState(true)
	const [curTraining, setCurTraining] = useState(newqualification)
	const handleCloseTraining = () => setShowTrainingEdit(false);
	const handleSaveTraining = () => {
		setShowTrainingEdit(false);
		let newtraining_list = element.qualification_list
		newtraining_list.push(curTraining)
		console.log(newtraining_list)
		functions.edit({ name: 'training_list', value: newtraining_list })
	}
	const handleShowNewTraining = () => {
		setCurTraining(newqualification)
		setNewTrainingEdit(true)
		setShowTrainingEdit(true)
	}
	const onChangeHandlerTraining = (event) => {
		console.log(event)
		const { name, value } = event
		console.log(name, value)
		setCurTraining({ ...curTraining, [name]: value })
	}
	return (
		<>
			<Form.Group as={Row} className="border-bottom">
				<Col sm="2">
					<Row>
						<Form.Label column sm="2">{t('employes.labels.training')}</Form.Label>
					</Row>
					<Row>
						<Col><Button disabled variant="outline-primary" size="sm" onClick={() => handleShowNewTraining()}><FontAwesomeIcon icon="plus-square" />{t('employes.buttons.add_training')}</Button></Col>
					</Row>
				</Col>
				<Col>
					{element.training_list && element.training_list.length > 0 ?

						<>
							<Row className="bg-secondary text-light">
								<Col sm="2" small>{t('employes.labels.date')} </Col>
								<Col>{t('employes.labels.qualification_level')} </Col>
								<Col>&nbsp;</Col>
							</Row>
							{element.training_list.map((i, key) => (
								<Row key={key}>
									<Col>{i.active}</Col>
									<Col>{i.level.name}</Col>
									<Col>{i.name.name}</Col>
									<Col>{format(i.trainigdate, 'dd/MM/yy')}</Col>
									<Col>
										<Button size="sm" variant="info"><FontAwesomeIcon icon="pencil-alt" /> </Button>
										<Button size="sm" variant="danger"><FontAwesomeIcon icon="trash" /> </Button>
									</Col>
								</Row>))
							}
						</>
						: ''
					}
				</Col>
			</Form.Group>
		</>
	)
} */
export default translate()(ModalEmployeeTraining)